import { useLocation } from 'react-router-dom';
import { useAliveController } from 'react-activation';


export function usePageCache(){
	const location=useLocation();
	const AliveController=useAliveController();
	let key=location.key

	return {
		key:key,
		deleteCachePage:()=>AliveController.drop(key),
		deleteAll:()=>{
			const names=AliveController.getCachingNodes().map(i=>i.name)
			console.log("deleteAll",names)
			names.map(name=>AliveController.drop(name))
		}
	}
}